import React from 'react';
import SubmitForm from '../submit-form';

interface LoginFormProps {
    children: React.ReactNode[];
}

const LoginForm = ({children}: LoginFormProps) => (
    <SubmitForm
        buttonLabel="Login"
        name="login"
        actionSlot={<a className="app-link" href="/Auth/Manage/ForgotPassword">Forgot your password?</a>}>
        {children}
    </SubmitForm>
);

export default LoginForm;
